import React, { FC } from 'react';

import PreloadImageLink from '~/components/PreloadImageLink/PreloadImageLink';
import SeoBlock from '~/components/SeoBlock/SeoBlock';
import { Video } from '~/types';
import env from '~/util/env';
import getCanonicalUrl from '~/utils/urlUtils/getCanonicalUrl';

interface VideoPageSeoBlockProp {
  video?: Video | null;
  isXApiPage: boolean;
}

const VideoPageSeoBlock: FC<VideoPageSeoBlockProp> = ({ video, isXApiPage }) => {
  const publishDate =
    video?.created_at && video.created_at.split(' ') ? video.created_at.split(' ')[0] : null;
  const url = `${process.env.REACT_APP_FU_SITE_LINK}/videos/${video?.video_url}/`;
  const canonicalUrl = getCanonicalUrl(`/videos/${video?.video_url}`, video?.tenants);

  return isXApiPage ? (
    <SeoBlock
      data={{
        robots_tag: 'noindex',
      }}
    />
  ) : (
    <>
      <SeoBlock
        data={{
          seo_title: video?.title,
          seo_description: video?.description,
          share_image: video?.preview_url,
          seo_author: video?.user?.name,
          publish_date: publishDate,
          url,
          //check for situation if searchable field is empty
          ...(process.env.REACT_APP_BUILD_TYPE !== 'prod' &&
            video?.searchable === false && { robots_tag: 'noindex' }),
          ...(env.isProd() && {
            robots_tag:
              video?.searchable === false
                ? 'noindex'
                : 'max-snippet:-1, max-image-preview:large, max-video-preview:0',
          }),
        }}
        canonicalUrl={canonicalUrl}
      />
      <PreloadImageLink path={video?.preview_url} />
    </>
  );
};

export default VideoPageSeoBlock;
